<template>
  <div>
    <div class="modal is-active" v-show="showDeleteModal">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Remove Supplier as Active</p>
          <button class="delete" aria-label="close"></button>
        </header>
        <section class="modal-card-body">
          Are you sure do you want to make {{supplier.companyName}} as <strong>"Inactive"</strong> supplier?
          <br/>
          <i>Note: Contact the developer if you want to permanently delete this.</i>
        </section>
        <footer class="modal-card-foot" style="justify-content:flex-end">
          <button :class="dangerButton" @click="deleteUser">Yes</button>
          <button class="button is-small" @click="closeModal">Cancel</button>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import axios from 'axios'
import AppToast from '../frontend/appToast'
import AppButton from '../frontend/appButton'

const appToast = new AppToast()
const appButton = new AppButton()

export default {
  data() {
    return {
      dangerButton: appButton.isLoadingDanger(false)
    }
  },
  computed: {
    ...mapState('supplier', {
      showDeleteModal: state => state.showDeleteModal,
      supplier: state => state.supplier
    })
  },
  methods: {
    ...mapActions('supplier', ['openDeleteModal', 'getPaginatedSuppliers']),
    deleteUser() {
      this.dangerButton = appButton.isLoadingDanger(true)
      axios
        .delete(`api/suppliers/${this.supplier.supplierId}`)
        .then(response => {
          appToast.success(response.data)
          this.default()
        })
        .catch(error => {
          console.log(error)
          appToast.danger(
            'Something went wrong. Cannot delete client'
          )
        })
        .then(() => {
          this.dangerButton = appButton.isLoadingDanger(false)
        })
    },
    closeModal() {
      this.default()
    },
    default() {
      this.openDeleteModal({
        showDeleteModal: false
      })
      this.getPaginatedSuppliers({
        page: 1,
        pageSize: 10,
        query: ''
      })
    }
  }
}
</script>
